import React, { useEffect } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, IconButton, List, ListItem, Tooltip, Typography } from "@material-ui/core";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditTextField from "../../EditArticle/EditTextField";
import { createArticles, updateArticle } from "../../../store/articles/ArticlesApi";
import EditSelect from "../../EditArticle/EditSelect";
import { setVatOptions } from "../../../store/articles/ArticlesActions";
import EditNumberField from "../../EditArticle/EditNumberField";
import Printgroups from "./Printgroups";
import Menugroups from "./Menugroups";
import EditPriceTextField from "../../EditArticle/EditPriceTextField";
import EditCheckbox from "../../EditArticle/EditCheckbox";
import { useDialog } from "../../Dialogs/DialogProvider";
import EditSwitch from "../../EditArticle/EditSwitch";
import PriceFieldArticle from "./PriceFieldArticle";
import { Close } from "@material-ui/icons";
import { Article } from "../../../store/articles/models/Article";
import { getTagsString } from "../../../store/articles/models/MenuTag";
import Button from "@material-ui/core/Button";
import Modifiergroups from "./Modifiergroups";
import OpeningHours from "../../OpeningHours/OpeningHours";
import cloudStore from "../../../store/CloudStore";
import { days } from "../../OpeningHours/WeekHours";

const useStyles = makeStyles(() => ({
  listAllergens: {
    display: "flex",
  },
  marginBottom10: {
    marginBottom: 10,
  },
  padding10: {
    padding: 10,
  },
  rootTitle: { marginRight: 40 },
}));

const getAverageFromArray = (array) => {
  let highestCount = 0;
  let commonValue = null;
  array.forEach((value) => {
    let count = 0;
    for (let i = 0; i < array.length; i++) {
      if (value === array[i]) {
        count++;
      }
    }
    if (highestCount < count) {
      highestCount = count;
      commonValue = value;
    }
  });
  return commonValue;
};

const getOccurance = (array, value) => {
  var count = 0;
  array.forEach((v) => v === value && count++);
  return count;
};

const getUniek = (array) => {
  return [...new Set(array)];
};

const makeArray = (array) => {
  const newArray = [];
  array.forEach((subArray) => subArray.forEach((element) => newArray.push(element)));
  return newArray;
};

const getMostCommon = (array, number) => {
  const newArray = makeArray(array);
  return getUniek(newArray)
    .map((uniekTag) => [getOccurance(newArray, uniekTag), uniekTag])
    .sort((a, b) => b[0] - a[0])
    .slice(0, number)
    .map((array) => array[1]);
};

function NewArticleDialog(props) {
  const classes = useStyles();
  const articles = props.articlegroup.articleIds?.map((id) => articlesStore.articles[id]);
  const vat_high = getAverageFromArray(articles.map((article) => article.vat_high));
  const price = getAverageFromArray(articles.map((article) => article.price));
  const max_n = getAverageFromArray(articles.map((article) => article.max_n));
  const weight = getAverageFromArray(articles.map((article) => article.weight));
  const menu_tags = getTagsString(
    getMostCommon(
      articles.map((article) => article.getMenuTags()),
      3
    )
  );
  const printTags = getTagsString(
    getMostCommon(
      articles.map((article) => article.getPrintTags()),
      3
    )
  );
  const allergenIds = getMostCommon(
    articles.map((article) => article.allergenIds),
    2
  );
  const modifiergroupIds = getMostCommon(
    articles.map((article) => article.modifiergroupIds),
    2
  );
  const filteredPlus = [];
  Object.keys(articlesStore.articles).forEach((key) => {
    if (!isNaN(articlesStore.articles[key].plu)) filteredPlus.push(articlesStore.articles[key].plu);
  });
  const newArticle = new Article(
    undefined,
    cloudStore.merchant.id,
    allergenIds,
    props.articlegroup.id,
    undefined,
    modifiergroupIds,
    undefined,
    price,
    Math.min(...props.articlegroup.articleIds.map((id) => articlesStore.articles[id].priority)) - 1,
    Math.max(...filteredPlus) + 1,
    1,
    weight,
    undefined,
    printTags,
    null,
    undefined,
    max_n,
    menu_tags,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    '{"00:00":"24:00"}',
    '{"00:00":"24:00"}',
    '{"00:00":"24:00"}',
    '{"00:00":"24:00"}',
    '{"00:00":"24:00"}',
    '{"00:00":"24:00"}',
    '{"00:00":"24:00"}',
    undefined,
    vat_high,
    undefined,
    undefined,
    "ARTICLE",
    1,
    undefined,
    null,
    null,
    null,
    null,
    0,
    null
  );

  const [article, setArticle] = React.useState(Object.assign(new Article(), newArticle));
  const [, closeDialog] = useDialog();

  const onChange = () => {
    setArticle(articlesStore.articles[props.articleId]);
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChange);
    return () => {
      articlesStore.removeListener(articlesStore.events.ARTICLES_UPDATED, onChange);
    };
  }, []);

  const handleCloseDialog = () => {
    if (newArticle.equals(article)) {
      closeDialog();
    } else {
      const cancel = window.confirm(props.intl.formatMessage({ id: "unsaved_changes_will_be_lost" }));
      if (cancel === true) {
        closeDialog();
      }
    }
  };

  const addOpeningsHoursToArticle = (newData) => {
    let newArticle = Object.assign(new Article(), article);
    days.forEach((day) => {
      newArticle[day] = newData[day];
    });
    setArticle(newArticle);
  };

  return (
    <>
      <DialogTitle id="form-dialog-title">
        <div style={{ display: "flex" }}>
          <Typography variant={"h5"} classes={{ h5: classes.rootTitle }}>
            {props.intl.formatMessage({ id: "add_article" })}
          </Typography>
          <EditSwitch
            key={article.key}
            authorizationField={"article.manual_active"}
            value={!!article.manual_active && !!article.active}
            disabled={!article.active}
            onChange={(newValue) => (article.manual_active = newValue)}
          />
        </div>
        <IconButton
          onClick={handleCloseDialog}
          color="primary"
          style={{ position: "absolute", top: "8px", right: "8px" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent key={article.key}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (isNaN(article.articlegroup_id)) {
              article.articlegroup_name = props.articlegroup.name;
              article.articlegroup_priority = props.articlegroup.priority;
            }
            createArticles(articlesStore.merchantId, [article]);
            closeDialog();
          }}
        >
          <Grid container>
            <Grid item container xs={12} md={6} alignContent={"flex-start"} spacing={1} className={classes.padding10}>
              <Grid item className={classes.marginBottom10} xs={6}>
                <EditTextField
                  inputProps={{ required: true }}
                  key={article.key}
                  authorizationField={"article.name"}
                  label={props.intl.formatMessage({ id: "article_name" })}
                  value={article.name == null ? "" : article.name}
                  onBlur={(value) => (article.name = value)}
                  variant={"standard"}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={3}>
                <PriceFieldArticle
                  inputProps={{ required: true }}
                  article={article}
                  onBlur={(value) => {
                    if (typeof article.meta_json?.originalPrice === "number") {
                      article.meta_json.originalPrice = value;
                    } else {
                      if (value == null) {
                        value = 0;
                      }
                      article.price = value;
                    }
                  }}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={3}>
                <EditPriceTextField
                  variant={"standard"}
                  authorizationField={"article.price"}
                  label={props.intl.formatMessage({ id: "action_price" })}
                  price={typeof article.meta_json?.originalPrice === "number" ? article.price : ""}
                  onBlur={(value) => {
                    let newOriginalPrice = null;
                    let price;
                    if (value > 0) {
                      newOriginalPrice = article.meta_json?.originalPrice
                        ? article.meta_json?.originalPrice
                        : article.price;
                      price = value;
                    } else {
                      price = article.meta_json?.originalPrice;
                    }

                    if (!props.articleId) {
                      article.meta_json = { originalPrice: newOriginalPrice };
                      article.price = price;
                    } else {
                      updateArticle(articlesStore.merchantId, article, {
                        meta_json: { originalPrice: newOriginalPrice },
                        price: price,
                      });
                    }
                  }}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={6}>
                <EditTextField
                  authorizationField={"article.print_name"}
                  label={props.intl.formatMessage({ id: "batch.print_name" })}
                  value={article.print_name == null ? "" : article.print_name}
                  onBlur={(value) => {
                    if (value === "") {
                      value = null;
                    }

                    !props.articleId
                      ? (article.print_name = value)
                      : updateArticle(articlesStore.merchantId, article, { print_name: value });
                  }}
                  variant={"standard"}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={6}>
                <EditTextField
                  authorizationField={"article.print_name_2"}
                  label={props.intl.formatMessage({ id: "batch.print_name_2" })}
                  value={article.print_name_2 == null ? "" : article.print_name_2}
                  onBlur={(value) => {
                    !props.articleId
                      ? (article.print_name_2 = value)
                      : updateArticle(articlesStore.merchantId, article, { print_name_2: value });
                  }}
                  variant={"standard"}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={12}>
                <EditTextField
                  multiline
                  rowsMax={6}
                  authorizationField={"article.description"}
                  label={props.intl.formatMessage({ id: "batch.description" })}
                  value={article.description == null ? "" : article.description}
                  onBlur={(value) => {
                    !props.articleId
                      ? (article.description = value)
                      : updateArticle(articlesStore.merchantId, article, { description: value });
                  }}
                  variant={"standard"}
                />
              </Grid>
              <Grid item xs={6}>
                <EditSelect
                  key={article.type}
                  authorizationField={"article.type"}
                  value={article.type == null ? "" : article.type}
                  optionValues={["ARTICLE", "SERVICE", "FREETPARTICLE"]}
                  optionViewValues={["ARTICLE", "SERVICE", "FREETPARTICLE"]}
                  onChange={(value) => (article.type = value)}
                />
              </Grid>
              <Grid item xs={6}>
                <EditTextField
                  authorizationField={"article.pos_name"}
                  label={props.intl.formatMessage({ id: "batch.pos_name" })}
                  value={article.pos_name == null ? "" : article.pos_name}
                  onBlur={(value) => {
                    !props.articleId
                      ? (article.pos_name = value)
                      : updateArticle(articlesStore.merchantId, article, { pos_name: value });
                  }}
                  variant={"standard"}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={6} sm={4}>
                <EditSelect
                  inputProps={{ required: true }}
                  key={article.key}
                  authorizationField={"article.vat_high"}
                  value={article.vat_high == null ? "" : article.vat_high.toString()}
                  optionValues={Object.keys(articlesStore.vatOptions)
                    .sort()
                    .map((vatOption) => vatOption)}
                  optionViewValues={Object.keys(articlesStore.vatOptions)
                    .sort()
                    .map((vatOption) => vatOption * 100 + "%")}
                  allowUnknown={true}
                  onUnknown={(value) => {
                    let articlesVat = { ...articlesStore.vatOptions };
                    articlesVat[value / 100.0] = true;
                    setVatOptions(articlesVat);
                    updateArticle(articlesStore.merchantId, article, { vat_high: value / 100.0 });
                  }}
                  onChange={(value) => {
                    if (value !== "+") {
                      !props.articleId
                        ? (article.vat_high = value)
                        : updateArticle(articlesStore.merchantId, article, { vat_high: value });
                    }
                  }}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={6} sm={4}>
                <EditNumberField
                  authorizationField={"article.weight"}
                  label={props.intl.formatMessage({ id: "batch.weight" })}
                  value={article.weight == null ? "" : article.weight}
                  onBlur={(value) => (article.weight = value)}
                  variant={"standard"}
                  fullWidth
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={6} sm={4}>
                <EditNumberField
                  variant={"standard"}
                  authorizationField={"article.max_n"}
                  label={"Max N"}
                  value={article.max_n == null ? "" : article.max_n}
                  onBlur={(value) => (article.max_n = value)}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={6} sm={8}>
                <EditNumberField
                  authorizationField={"article.remark"}
                  value={article.meta_json?.remark >= 0 ? article.meta_json.remark : ""}
                  label={"# of characters for remark"}
                  helperText={"0 for unlimited"}
                  onBlur={(value) => {
                    if (value < 0) {
                      value = "";
                    }
                    updateArticle(articlesStore.merchantId, article, {
                      meta_json: { remark: value === "" ? false : Number.parseInt(value) },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <EditCheckbox
                  labelPlacement={"start"}
                  color={"primary"}
                  authorizationField={"article.handheld_only"}
                  value={article.handheld_only}
                  label={props.intl.formatMessage({ id: "handheld_only" })}
                  onChange={(value) => (article.handheld_only = value)}
                />
              </Grid>
              <Grid item xs={6}>
                <EditCheckbox
                  labelPlacement={"start"}
                  authorizationField={"article.active"}
                  value={article.active}
                  label={props.intl.formatMessage({ id: "batch.active" })}
                  onChange={(value) => (article.active = value)}
                />
              </Grid>
              <Grid item xs={11}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Typography>{props.intl.formatMessage({ id: "order_hours" })}</Typography>
                </div>
                <OpeningHours
                  size="small"
                  openingHours={article}
                  onSave={(newData) => {
                    addOpeningsHoursToArticle(newData);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container xs={12} md={6} spacing={1} className={classes.padding10}>
              <Grid item className={classes.marginBottom10} xs={12}>
                <Typography> {props.intl.formatMessage({ id: "batch.allergenIds" })}</Typography>
                <div style={{ width: "auto" }}>
                  <EditSelect
                    authorizationField={"article.allergens"}
                    value={article.allergenIds}
                    optionValues={Object.keys(articlesStore.allergens).map((allergenId) => parseInt(allergenId))}
                    optionViewValues={Object.keys(articlesStore.allergens).map((allergenId) => {
                      return articlesStore.allergens[allergenId].name;
                    })}
                    multiple={true}
                    onChange={(value) => (article.allergenIds = value)}
                  />
                </div>
                {article.allergenIds.length > 0 ? (
                  <List classes={{ root: classes.listAllergens }}>
                    {article.allergenIds.map((allergenId) => (
                      <ListItem
                        key={allergenId}
                        style={{
                          margin: "0 1px 1px 1px",
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip
                          placement={"top"}
                          title={articlesStore.allergens[allergenId].name}
                          style={{ fontSize: "18pt" }}
                        >
                          <img
                            style={{
                              height: "24px",
                              width: "24px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                            alt={articlesStore.allergens[allergenId].name}
                            src={articlesStore.allergens[allergenId].getImagePath()}
                          />
                        </Tooltip>
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography>Geen allergenen</Typography>
                )}
              </Grid>
              <Grid item className={classes.marginBottom10} xs={12}>
                <Printgroups
                  article={article}
                  onChange={(value) => {
                    !props.articleId
                      ? (article.tag = getTagsString(value))
                      : updateArticle(articlesStore.merchantId, article, { printTags: getTagsString(value) }, false);
                  }}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={12}>
                <Menugroups
                  article={article}
                  onChange={(value) => {
                    !props.articleId
                      ? (article.menu_tags = getTagsString(value))
                      : updateArticle(articlesStore.merchantId, article, { menu_tags: getTagsString(value) }, false);
                  }}
                />
              </Grid>
              <Grid item className={classes.marginBottom10} xs={12}>
                <Modifiergroups
                  article={article}
                  onChange={(value) => {
                    !props.articleId
                      ? (article.modifiergroupIds = value)
                      : updateArticle(articlesStore.merchantId, article, { modifiergroupIds: value }, false);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Button variant={"outlined"} type="submit" style={{ marginRight: "5px", float: "right" }} variant="standard">
            {props.intl.formatMessage({ id: "add" })}
          </Button>
        </form>
      </DialogContent>
    </>
  );
}

export default withIntl(NewArticleDialog);
